/**
 * Created by sswaminathan on 1/6/23
 * File: BackBoneRegionModal
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

import { Input } from '@panwds/react-form'
import { Body } from '@panwds/react-ui'
import { capitalize } from 'lodash'
/**
 *   TODO: Brief what is this component/class do
 */
import { useState, useCallback, useMemo } from 'react'
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalCloseButton,
  Button
} from '@panwds/react-ui'
import { useFormContext } from 'react-hook-form'
import ZIndex from '../../../../../common/components/zIndex/ZIndex'
import { EXCLUDE_REGION_HEADER, SAVE_BUTTON } from '../../../constants/SubscriptionConstant'
import BackBoneRegionModalBody from './BackBoneRegionModalBody'

const BackBoneRegionModal = (props) => {
  const [isOpen, setIsOpen] = useState(false)
  const [excludedRegionList, setExcludedRegionList] = useState([])
  const { setValue } = useFormContext()
  const openModal = useCallback(() => {
    setIsOpen(true)
  }, [])
  const regionInformation = useMemo(() => {
    const response = excludedRegionList?.map((each) => {
      return capitalize(each.region)
    })
    setValue('backboneRegion', response?.join(', '))
    return response
  }, [excludedRegionList, setValue])

  const closeModal = useCallback(() => {
    setIsOpen(false)
  }, [])

  return <>
    <div className='tw-flex tw-flex-row'>
      <Button onClick={openModal}>{EXCLUDE_REGION_HEADER}</Button>
      <Body size="md" addClassName='tw-ml-4 tw-mt-1 tw-justify-items-center	'>{regionInformation?.join(', ')}</Body>
    </div>
    <div style={{ display: 'none' }}>
      <Input
        name='backboneRegion'
        label={'excludedRegion'}
        value={regionInformation?.join(', ')}
        register={{
          required: false,
        }}/>
    </div>
    <ZIndex><Modal style={{ top: '12%', height: '600px', width: '500px' }}
      size="md"
      confirmClose={false}
      onClose={closeModal}
      isOpen={isOpen}
    >
      <ModalHeader title={EXCLUDE_REGION_HEADER} enableClose={false} />
      <ModalBody addClassName="tw-overflow-auto" style={{ padding: '0px' }}>
        <BackBoneRegionModalBody {...{ setExcludedRegionList, regionInformation, ...props }}/>
      </ModalBody>
      <ModalFooter>
        <ModalCloseButton>{SAVE_BUTTON}</ModalCloseButton>
      </ModalFooter>
    </Modal> </ZIndex>
  </>
}

export default BackBoneRegionModal
